import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import PropertySectionsProps from '../../../../interfaces/PropertySectionsProps';
import * as appContext from '../../../AppContext';
import BottomSections from '../../../BottomSections';
import Header from '../../../Header';
import Jumbotron from '../../../Jumbotron';
import Content from '../../../templates/property/Content';
import PropertyHeading from "../content/columned/left/PropertyHeadingDescViewPort";
import PropertyHeadingTop from "../content/columned/left/PropertyHeadingTopDescViewPort";
import {fetchBuilderSettingByKey} from "../../../../helpers/MethodHelper";
import LgConsts from "../../../../helpers/LgConsts";
import Checkers from "../../../../helpers/class/Checkers";

export const PropertySections: React.FC<PropertySectionsProps> = ( props ) => {
  const app = props.app;
  const builder = props.builder;
  const head = props.head;
  const footer = props.footer;

  const app_data = props.app_data;
  const locations = props.locations;
  const navigation = props.navigation;
  const content = props.content;
  const details = props.content.details;

  const isDesktop = props.isDesktop;

  const contactIcons = {
    phoneIcon: app.showPhoneIconOnMenu,
    chatIcon: app.showChatIconOnMenu,
    mailIcon: app.showMailIconOnMenu,
    phoneIconData: app.menuPhoneIconData,
    chatIconData: app.menuChatIconData,
    mailIconData: app.menuMailIconData
  }

  const titlePositionBeforeJumbotron = useSelector(
      state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_title_position')
  );

  const systemModuleTypeId = props.content.details.system_type_id

  return (
      <>
        {
          titlePositionBeforeJumbotron==1 ?
              <PropertyHeadingTop
                  details={details}
                  location={content.location}
                  readMore={false}
              />
              :
              <></>
        }
        {
          Checkers.isValidArray(props.all_images) ?
              <>
                <Jumbotron
                    isDesktop={isDesktop}
                    isManager={app_data.is_manager}
                    withMotto={false}
                    content={content.details}
                    motto={null}
                    album={props.all_images}
                    designMode={app.designMode}
                    propertyJumbotronHeight={app.propertyJumbotronHeight}
                    jumbotronAutoplay={false}
                    propertyJumbotronOverlayOpacity={app.propertyJumbotronOverlayOpacity}
                    jumbotronTextAlign={app.jumbotronTextAlign}
                    jumbotronTextColor={app.jumbotronTextColor}
                    sliderTitleShadow={app.sliderTitleShadow}
                    sliderTitleBold={app.sliderTitleBold}
                    sliderThumbnails={app.sliderThumbnails}
                    video={content.details.hasOwnProperty('video') && content.details.video != null ? content.details.video.length > 0 ? content.details.video : null : null}
                    homeTitle={app.hasOwnProperty('homeTitle') && app.homeTitle != null ? app.homeTitle.length > 0 ? app.homeTitle : null : null}
                    homeSubtitle={app.hasOwnProperty('homeSubtitle') && app.homeSubtitle != null ? app.homeSubtitle.length > 0 ? app.homeSubtitle : null : null}
                    sliderSearchBar={null}
                    property={true}
                    propertyJumbotronType={app.propertyJumbotronType}
                    details={details}
                />
              </>
              :
              <></>
        }
        <Content
            app={app}
            app_data={app_data}
            builder={builder}
            details={content.details}
            terms={content['terms']}
            location={content.location}
            images={content.album}
            images_count={content.images_count}
            all_images={props.all_images}
            spaces={content.spaces}
            features={props.features}
            services={content.services}
            highlights={content.highlights}
            themes={content.themes}
            googleMapShow={app.viewMap}
            googleMapApiKey={app.googleMapsApiKey}
            page_title={props.page_title}
            map_pois={content.map_pois}
            phone={props.phone}
            hasOpenCalendar={content.hasOpenCalendar}
        />
      </>
  )
}

export default PropertySections;
